<mat-card>
  <mat-card-header>
    <mat-card-title class="popupHeader">
      <div class="mat-card-header-text" i18n>
        New User
      </div>        
    </mat-card-title>   
  </mat-card-header>

  <mat-card-content>
    <form>
      <mat-form-field class="my-form-field">
        <mat-label i18n>User Name</mat-label>
        <input matInput  [formControl]="name" required>
      </mat-form-field>
      <mat-form-field class="my-form-field">
        <mat-label i18n>Password</mat-label>
        <input matInput  type="password" [formControl]="password" name="password" required>
      </mat-form-field>
      <mat-form-field class="my-form-field" required>
        <mat-label i18n>Role</mat-label>
        <mat-select (valueChange)="selectedRole($event)">
          <mat-option *ngFor="let role of roles" [value]="role">
            {{role}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <form>
      <mat-form-field class="my-form-field">
        <mat-label i18n>First Name</mat-label>
        <input matInput [formControl]="firstName" required>
      </mat-form-field>
      <mat-form-field class="my-form-field">
        <mat-label i18n>Last Name</mat-label>
        <input matInput [formControl]="lastName" required>
      </mat-form-field>
      <mat-form-field class="my-form-field" required>
        <mat-label i18n>Email</mat-label>
        <input matInput [formControl]="email" required>
      </mat-form-field>
      <mat-form-field class="my-form-field">
        <mat-label i18n>Company</mat-label>
        <input matInput [formControl]="company" required>
      </mat-form-field>
    </form>
  </mat-card-content>

  <mat-card-actions>
    <div class="buttonContent">      
      <button mat-raised-button type="button" color="primary" (click)="createNewUser()" i18n>CREATE</button>
    </div>   
  </mat-card-actions>
  <!-- *ngIf=" name.valid&&password.valid&&email.valid&&firstName.valid&&lastName.valid&&company.valid" -->
</mat-card>